const Backend = {
  SA: 'sa', // SilverAgent
  BFF: 'bff' // BFF
};

export default Backend;